export default __webpack_public_path__ + "static/media/windows.e0e7cc21.svg";